import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ContractConfirmation from './ContractConfirmation';
import { APPLICATION_CONTRACT_TYPES } from '../../constants';
import { getDraftRoadCareContractAndSaveInCache } from '../../redux/modules/roadCareContract';
import { getCountries, getStates } from '../../redux/modules/countries';

import RoadCareCalcHeader from '../../img/roadCareCalcHeader.svg';

const RoadCareContractConfirmation = () => {
  const dispatch = useDispatch();
  const { loadingDraftContract, savingContractInCache } = useSelector(
    (state) => state.roadCareContract, shallowEqual,
  );

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getStates());
  }, [dispatch]);

  return (
    <ContractConfirmation
      headerText="roadCareContract.title"
      headerImage={RoadCareCalcHeader}
      type={APPLICATION_CONTRACT_TYPES.ROAD_CARE}
      loadingOrSavingInCache={loadingDraftContract || savingContractInCache}
      getDraftContractAndSaveInCache={getDraftRoadCareContractAndSaveInCache}
      imageWidth={50}
    />
  );
};

export default RoadCareContractConfirmation;
